import { render, staticRenderFns } from "./HeadroomWrapper.vue?vue&type=template&id=315a7a7c"
import script from "./HeadroomWrapper.vue?vue&type=script&lang=js"
export * from "./HeadroomWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports